import MuiPhoneNumber, {
  MaterialUiPhoneNumberProps
} from 'material-ui-phone-number'
import * as React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { createStyles, makeStyles, Theme } from '../../../themes/ThemeProvider'
import { TextFieldProps, useStyles as useInputStyles } from '../Input'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    muiInputRoot: {
      marginBottom: theme.spacing(2.5)
    }
  })
)

interface Props extends MaterialUiPhoneNumberProps {
  name: string
  label?: string
  placeholder?: string
  style?: object
  readOnly?: boolean
  autoFormat?: boolean
  onlyCountries?: string[]
  defaultCountry?: string,
}

export type PhoneInputProps = Props & TextFieldProps

export const FormPhoneField: React.FC<PhoneInputProps> = (props) => {
  const classes = useInputStyles(props)
  const phoneFieldClasses = useStyles(props)
  const {
    style,
    name,
    label,
    defaultCountry,
    onlyCountries,
    defaultValue,
    readOnly,
    customSize,
    InputProps,
    FormHelperTextProps = {},
    formContext,
    ...rest
  } = props

  const formContextLocal = useFormContext()
  const { control, errors } = formContext || formContextLocal

  const getSizeInputRoot = (size: string | undefined): string => {
    switch (size) {
      case 'small':
        return classes.muiInputRootSmall
      case 'medium':
        return classes.muiInputRootMedium
      case 'large':
        return classes.muiInputRootLarge
      default:
        return classes.muiInputRootMedium
    }
  }

  const inputProps = {
    readOnly,
    ...InputProps,
    classes: {
      root: `${classes.muiInputRoot} ${phoneFieldClasses.muiInputRoot}`,
      input: getSizeInputRoot(customSize),
      focused: classes.muiInputFocus,
      multiline: classes.muiInputmultiline
    },
    notched: false
  }

  const inputLabelProps = {
    classes: {
      root: classes.muiInputLabelRoot,
      formControl: classes.muiInputLabelFormControl,
      shrink: 'shrink'
    },
    shrink: true
  }

  const formHelperTextPropsClasses = FormHelperTextProps.classes

  const formHelperTextProps = {
    ...FormHelperTextProps,
    classes: {
      root: classes.MuiFormHelperTextRoot,
      contained: classes.MuiFormHelperTextContained,
      ...formHelperTextPropsClasses
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ name, onBlur, onChange, value }) => (
        <MuiPhoneNumber
          InputProps={inputProps}
          autoFormat={false}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          defaultCountry={defaultCountry}
          onlyCountries={onlyCountries}
          style={style}
          label={label}
          variant="outlined"
          helperText={errors[`${name}`]?.message}
          error={!!errors[`${name}`]}
          FormHelperTextProps={formHelperTextProps}
          inputProps={{ 'data-testid': name }}
          InputLabelProps={inputLabelProps}
          {...rest}
        />
      )}
    />
  )
}

FormPhoneField.defaultProps = {
  label: 'Enter phone number',
  defaultCountry: 'sg',
  onlyCountries: ['sg'],
  style: { width: '100%' },
  autoFormat: true,
  readOnly: false
}
